import React, { useEffect, useState } from "react";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls, url } from "../../Utils/url";
import { connect } from "react-redux";
import InnerHeader from "../../Components/Common/InnerHeader";
import Loader from "react-loader-spinner";
import { getBillStatus } from "../Payment/Payment";
import { toast } from "react-toastify";

const getReminders = (token, setReminder, setLoading) => {
  ApiCall(
    "get",
    `${urls.GetReminder}`,
    null,
    "get reminders",
    token,
    function (e) {
      setReminder(e.data);
      setLoading(false);
    },
    function (error) {
      setLoading(false);
    }
  );
};

const PayBill = (billId, token, setBillParam) => {
  const body = {
    bill_id: billId,
    reminder: 1,
  };
  ApiCall("post", `${urls.Payment}`, body, "payBill", token, function (e) {
    window.open(`${url}Payment/${e.data.invoice_number}`);
    setBillParam(billId);
  });
};

const ProfileInfo = ({ name, text }) => {
  return (
    <div>
      <span>{text}</span>
      <span>{name}</span>
    </div>
  );
};
export const CompanyImage = (companyId) => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};
const CompanyText = (companyId, data) => {
  switch (companyId) {
    case 1:
      return data.info.CustomerName || data.info.OwnerName;
    case 2:
      return data.info.CustomerName || data.info.OwnerName;
    case 3:
      return data.info.CustomerName || data.info.OwnerName;
    case 4:
      return "همراه اول";
    case 5:
      return "تلفن ثابت";
    default:
      break;
  }
};
const ReminderComponent = ({ bill, token, setBillParam }) => {
  return (
    <div className="ReminderComponentContainer">
      <img src={CompanyImage(bill.bill_company_id)} alt="" />
      <div>
        <ProfileInfo name={"شماره"} text={bill.parameter} />
        <ProfileInfo
          name={"نوع قبض"}
          text={bill.end_of_period === 1 ? "پایان دوره" : "میان دوره"}
        />
        <ProfileInfo
          name={"مبلغ"}
          text={` ${bill.amount.toLocaleString()} ریال`}
        />
        <ProfileInfo name={"شناسه قبض"} text={bill.bill_id} />
      </div>
      {!bill.payment_status || bill.payment_status === 0 ? (
        <div
          className="LoginButton bottomBtn"
          onClick={() => PayBill(bill.id, token, setBillParam)}
        >
          پرداخت
        </div>
      ) : (
        <div className="LoginButton bottomBtn isPaid">
          <span>پرداخت شده</span>
        </div>
      )}
    </div>
  );
};
function WaitingForPay({ ...props }) {
  const [reminders, setReminders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(0);
  const [windowFocused, setWindowFocused] = useState(true);
  const [billParam, setBillParam] = useState("");
  useEffect(() => {
    getReminders(props.token, setReminders, setLoading);
  }, []);
  function handleActivity(forcedFlag) {
    if (typeof forcedFlag === "boolean") {
      return forcedFlag ? setWindowFocused(true) : setWindowFocused(false);
    }

    return document.hidden ? setWindowFocused(false) : setWindowFocused(true);
  }
  useEffect(() => {
    document.addEventListener("visibilitychange", handleActivity);
    return () => {
      document.removeEventListener("visibilitychange", handleActivity);
    };
  });
  useEffect(() => {
    billParam && getBillStatus(billParam, props.token, setPaymentStatus);
    if (paymentStatus === 1 && windowFocused) {
      toast.success("پرداخت قبض با موفقیت انجام شد", {
        position: "bottom-center",
      });
    }
  }, [windowFocused, props.token, paymentStatus]);
  return (
    <div className="container">
      <InnerHeader isLogin={props.isLogin} />
      <h4 className="historySpan">در انتظار پرداخت</h4>
      {loading && (
        <Loader type="Grid" color={"#ec4d11"} width={100} height={100} />
      )}
      {!loading && reminders.length !== 0 && (
        <>
          <div className="paymentsContainer" id="paymentsContainer">
            {reminders
              .filter((i) => i.bill_company_id === 4 || i.bill_company_id === 5)
              .map((i) => (
                <ReminderComponent
                  bill={i}
                  token={props.token}
                  setBillParam={setBillParam}
                />
              ))}
          </div>
        </>
      )}
      {!loading && reminders.length === 0 && (
        <div
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            width: "100%",
          }}
        >
          <span className="historySpanEmpty">!موردی برای نمایش وجود ندارد</span>
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    bills: state.persistedParams.bills,
    token: state.auth.token,
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(WaitingForPay);
